var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77997 21L21.53 3",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.0499C9.97098 19.353 10.9828 19.5047 12 19.4999C16.1 19.5699 20.26 16.6899 22.82 13.8599C23.0962 13.5562 23.2492 13.1604 23.2492 12.7499C23.2492 12.3394 23.0962 11.9436 22.82 11.6399C21.8943 10.6168 20.8655 9.69186 19.75 8.87988",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.09 7.27006C15.5163 6.45364 13.7727 6.01861 12 6.00006C7.99997 5.93006 3.79997 8.75006 1.17997 11.6401C0.903816 11.9438 0.750793 12.3395 0.750793 12.7501C0.750793 13.1606 0.903816 13.5563 1.17997 13.8601C2.59986 15.4474 4.26415 16.7977 6.10997 17.8601",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.07C8.45752 14.3174 8.20504 13.3943 8.289 12.4703C8.37295 11.5464 8.7877 10.6839 9.45695 10.0414C10.1262 9.39893 11.0049 9.01972 11.9315 8.97353C12.8581 8.92734 13.7702 9.21727 14.5 9.79001",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12.75C15.75 13.2425 15.653 13.7301 15.4645 14.1851C15.2761 14.64 14.9999 15.0534 14.6517 15.4017C14.3034 15.7499 13.89 16.0261 13.4351 16.2145C12.9801 16.403 12.4925 16.5 12 16.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibility-off.e615c8e8a469f732ec93c874edf560d7.svg";
export { ForwardRef as ReactComponent };